module.exports = __webpack_public_path__ + "img/midday-bg.abf234a8.png";